/**
 * i18n setup · react-i18next con detector de idioma del navegador.
 *
 * Idiomas soportados: español (es, default) e inglés (en).
 * Persistencia: localStorage clave `valoriza_lang`.
 *
 * Para añadir traducciones de un módulo nuevo:
 *   1. Añade los strings al objeto `es` y `en` en `/locales/{idioma}.js`
 *   2. En tu componente: `const { t } = useTranslation();`
 *   3. Usa: `<span>{t("mi.modulo.titulo")}</span>`
 *
 * Convención de keys: usar dot-notation con módulo como prefijo
 *   - common.cancel, common.save, common.delete...
 *   - layout.sidebar.dashboard, layout.header.search...
 *   - login.title, login.email, login.password...
 *   - delegado.kpi.total, delegado.empty...
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import es from "./locales/es";
import en from "./locales/en";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    fallbackLng: "es",
    supportedLngs: ["es", "en"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "valoriza_lang",
      caches: ["localStorage"],
    },
  });

export default i18n;
